export default "__VITE_ASSET__D30F0QDZ__"